// frontend/admin-portal/src/services/supplierService.js
import api from './axiosConfig';

export const supplierService = {
    list: async (params = {}) => {
        const { data } = await api.get('/suppliers', { params });
        return data.data;   // { items, pagination }
    },
    stats: async () => {
        const { data } = await api.get('/suppliers/stats');
        return data.data;
    },
    get: async (idOrSlug) => {
        const { data } = await api.get(`/suppliers/${idOrSlug}`);
        return data.data.supplier;
    },
    create: async (payload) => {
        const { data } = await api.post('/suppliers', payload);
        return data.data.supplier;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/suppliers/${id}`, payload);
        return data.data.supplier;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/suppliers/${id}`);
        return data;
    },

    // ---- Links ----
    linkProduct: async (supplierId, payload) => {
        const { data } = await api.post(`/suppliers/${supplierId}/products`, payload);
        return data.data;   // { link, created }
    },
    updateLink: async (supplierId, productId, payload) => {
        const { data } = await api.put(`/suppliers/${supplierId}/products/${productId}`, payload);
        return data.data.link;
    },
    unlinkProduct: async (supplierId, productId) => {
        const { data } = await api.delete(`/suppliers/${supplierId}/products/${productId}`);
        return data;
    },
};